<div class="d-flex justify-content-center">
  <div class="sa">
    <div class="sa-success">
      <div class="sa-success-tip"></div>
      <div class="sa-success-long"></div>
      <div class="sa-success-placeholder"></div>
      <div class="sa-success-fix"></div>
    </div>
  </div>
</div>
